module.exports = __webpack_public_path__ + "media/images/ride_requests/map_dots-fbb47de45c854db7dc95ac494ae724cf.svg";